const Economy = {
  HERO_UNLOCK_COST: [
    10, 25, 50, 100, 250, 500, 750, 1000, 1500, 2000, 2500, 5000, 7500, 10000,
  ], // pixie dust, total(11): 8,685
  ABILITY_RESET_COST: 50, // ability points
  ATT_RESET_COST: 50, // att points

  ALTAR_ACCESS_REQ: 5000, // gold
  MIN_GOLD_SACRIFICE: 100, // gold
  MAX_GOLD_SACRIFICE: 12345, // gold
  MAX_PRAYER_SLOTS: 5,
  PRAYER_SLOT_UNLOCK_COSTS: [0, 250, 500, 1000, 2000], // pixie dust
  GLOBAL_BAG_SLOT_UNLOCK_COST: [0, 100, 250, 500, 1500], // pixie dust
  MAX_GLOBAL_BAG_SLOTS: 5,
  HERO_BAG_SLOT_UNLOCK_COST: [0, 100, 300], // pixie dust
  MAX_HERO_BAG_SLOTS: 3,

  GOLD_PER_PD: 2345,

  EQUIPMENT_DYE_PRICE: 10 * 1000,

  SET_CHAT_TEXT_COLOR_COST: 1000, // pixie dust

  CAVERNS_FEE_PER_LEVEL: 100, // gold

  PREMIUM_ITEM_DICT: {
    pd_1000: {
      usd_cents: 499,
      pd_amount: 1000,
    },
    pd_2500: {
      usd_cents: 999,
      pd_amount: 2500,
    },
    pd_7000: {
      usd_cents: 2499,
      pd_amount: 7000,
    },
    pd_15500: {
      usd_cents: 4999,
      pd_amount: 15500,
    },
    pd_35000: {
      usd_cents: 9999,
      pd_amount: 35000,
    },
  },

  RESURRECTION_SCROLL_PD_PRICE: 20,
};
module.exports = Economy;
